import { SpyneTrait, safeClone } from "spyne";
import { UiExternalEventsBtn } from "components/ui/ui-external-events-btn";
import { UtilTraits } from "traits/util-traits";

export class ExternalEventsTraits extends SpyneTrait {
  constructor(context) {
    let traitPrefix = "externalEvent$";

    super(context, traitPrefix);
  }

  static externalEvent$HelloWorld() {
    return "Hello World";
  }

  static externalEvent$CheckToAddExtBtnsToPlaygroundHeader(
    codePayload,
    data,
    props = this.props,
  ) {
    const { scriptString } = codePayload;

    const { codeBlockId, parentVsid } = props;

    const { externalEvents } = data;

    /**
     * TODO: FIX data duplicating bug
     * */

    //console.log("EXT ",{codePayload, externaleEvents, scriptString},props)

    const addExternalBtn = (d) => {
      const data = safeClone(d);
      const { getExtValFromCode, externalEvent } = data;

      if (getExtValFromCode === true) {
        data["externalEventVal"] = scriptString;
      }

      //console.log("DATA IS ",{codeBlockId, externalEvent})

      this.appendView(
        new UiExternalEventsBtn({ data, parentVsid, codeBlockId }),
        ".external-events-btn-holder",
      );
    };

    if (externalEvents !== undefined) {
      externalEvents.forEach(addExternalBtn);
    }
  }

  static externalEvent$CopyToClipboard(str) {
    UtilTraits.util$CopyToClipboard(str);
  }

  static externalEvent$OpenWindow(url) {
    UtilTraits.util$OpenWindow(url);
  }

  static externalEvent$CallEvent(event, eventVal) {
    const evtHash = {
      copy: ExternalEventsTraits.externalEvent$CopyToClipboard,
      stackblitz: ExternalEventsTraits.externalEvent$OpenWindow,
    };

    const fn = evtHash[event];

    fn(eventVal);
  }

  static externalEvent$LaunchWindow(url) {}

  static externalEvent$CheckToUpdateCopyBtn(scriptString, props = this.props) {
    const { externalEvents } = this.props;

    const checkForCopyBtn = (o) => {
      const { externalEvent, getExtValFromCode } = o;

      if (String(getExtValFromCode) === "true") {
      }
    };
  }
}
